import type { FC } from 'react';
import { useRouter } from 'next/router';
import { removeURLSearchParams, selectUserIsAuthenticated, useWidgetMatchActiveTab } from '@mwl/core-lib';
import { Button } from '@/components/Button/Button';
import { SportButtonFavorites } from '@/components/SportButtonFavorites/SportButtonFavorites';
import { useTypedSelector } from '@/hooks';
import { getAnalyticsData } from '../MatchWidgetTabs/MatchWidgetTabs.analitycs';
import type { MatchTopNavProps } from './MatchTopNav.types';
import styles from './MatchTopNav.module.scss';
export const MatchTopNav: FC<MatchTopNavProps> = ({
  tabs,
  hasTranslation,
  lineId,
  isFavorite,
  className,
  children,
  analyticsAddFavorites,
  analyticsDeleteFavorites
}) => {
  const router = useRouter();
  const isAuth = useTypedSelector(selectUserIsAuthenticated);
  const activeTab = useWidgetMatchActiveTab({
    tabs,
    hasTranslation
  });
  return <>
      <nav className={cn(styles.root, className)}>
        {isAuth && <div className={cn(styles.favorites, {
        [styles.active]: isFavorite
      })}>
            <SportButtonFavorites analyticsAddFavorites={analyticsAddFavorites} analyticsDeleteFavorites={analyticsDeleteFavorites} size="md" isFavorite={isFavorite} lineId={lineId} />
          </div>}

        <div className={styles.tabs}>
          {tabs.map(tab => {
          const {
            key,
            icon: Icon,
            disabled
          } = tab;
          const isActive = activeTab === key;
          if (disabled) {
            return null;
          }
          return <Button key={key} as="link" href={{
            pathname: removeURLSearchParams({
              url: router.asPath
            }),
            query: {
              wt: key
            }
          }} shallow analytics={getAnalyticsData((router?.query?.line_id as string), tab)} replace scroll={false} variant="text" color="grey" size="sm" className={styles.tab} aria-label={`match top ${tab.key}`}>
                <Icon className={cn(styles.tabIcon, {
              [styles.tabIconActive]: isActive
            })} />
              </Button>;
        })}
        </div>
      </nav>

      {children?.(activeTab)}
    </>;
};